import { render, staticRenderFns } from "./caseManagementForm.vue?vue&type=template&id=fec65a88&scoped=true"
import script from "./caseManagementForm.vue?vue&type=script&lang=js"
export * from "./caseManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec65a88",
  null
  
)

export default component.exports